import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Button, Grid, IconButton, Menu, MenuItem } from "@mui/material";
import { useAppContext } from "AppContext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { theme } from "utils/Theme";

function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const {
    state: { currentUser },
  } = useAppContext();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
    window.location.reload();
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid container>
      <Grid
        item
        container
        display={"flex"}
        justifyContent={"space-between"}
        p={1}
        borderBottom={"solid 1px #E3E8EF"}
      >
        <Grid item>
          <img
            src="https://gridkey.in/Logos/Gridkey_BrandGuidelines-removebg-preview.png"
            alt="Gridkey Logo"
            width="auto"
            height="40"
          />
        </Grid>
        <Grid item display={"flex"} alignItems={"center"} gap={1}>
          <Button
            variant="text"
            sx={{
              textTransform: "capitalize",
              padding: 1,
              minWidth: "1px",
              background: `${theme.palette.primary.main}11`,
            }}
            onClick={() => navigate("/app/dashboard")}
          >
            Dashboard
          </Button>
          <Button
            variant="text"
            sx={{
              textTransform: "capitalize",
              padding: 1,
              minWidth: "1px",
              background: `${theme.palette.primary.main}11`,
            }}
            onClick={() => navigate("/app/user")}
          >
            Users
          </Button>
          <Button
            variant="text"
            sx={{
              textTransform: "capitalize",
              padding: 1,
              minWidth: "1px",
              background: `${theme.palette.primary.main}11`,
            }}
            onClick={() => navigate("/app/admin-access-board")}
          >
            Admin Access Panel
          </Button>
          {(currentUser.phone === "7016333333" ||
            currentUser.phone === "9911223344") && (
            <Button
              variant="text"
              sx={{
                textTransform: "capitalize",
                padding: 1,
                minWidth: "1px",
                background: `${theme.palette.primary.main}11`,
              }}
              onClick={() => navigate("/app/company-master")}
            >
              Company Master
            </Button>
          )}

          <Button
            variant="text"
            sx={{
              textTransform: "capitalize",
              padding: 1,
              minWidth: "1px",
              background: `${theme.palette.primary.main}11`,
            }}
            onClick={() => navigate("/app/broker-master")}
          >
            Broker Master
          </Button>
          <Button
            variant="text"
            sx={{
              textTransform: "capitalize",
              padding: 1,
              minWidth: "1px",
              background: `${theme.palette.primary.main}11`,
            }}
            onClick={() => navigate("/app/faq")}
          >
            FAQ
          </Button>
          <Button
            variant="text"
            sx={{
              textTransform: "capitalize",
              padding: 1,
              minWidth: "1px",
              background: `${theme.palette.primary.main}11`,
            }}
            onClick={() => navigate("/app/communication")}
          >
            Communication
          </Button>
        </Grid>
        <Grid item>
          <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
            <AccountCircleIcon fontSize="large" />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        maxHeight={"calc(100vh - 61px)"}
        bgcolor={"#f9f9f9"}
        overflow={"auto"}
        p={1}
      >
        {children}
      </Grid>
    </Grid>
  );
}

export default DashboardLayout;
